import { TUtm } from '../../../types/utm';

export const shouldShowPhoneButton = (utm?: TUtm) => {
  return !(utm?.source === 'cian_app' && utm?.medium === 'push');
};
